// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"lL-z","carouselContainer":"mL-z"};